/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { ListUserInfo, ListItemButton } from '@components/molecules'
import { mono } from '@components/systems/backoffice/backoffice.tokens'

import { User, UserType } from '@schemas'

interface PropsType {
	user?: UserType
	isChecked?: boolean
	chechedStyle?: React.CSSProperties
	onUserClick?: (aUser: UserType) => void
	showDepartmentName?: boolean
	userInfoStyle?: React.CSSProperties
	userInfoClassName?: string
	userInfoLeftAccessory?: (aUser: UserType) => JSX.Element
	children?: JSX.Element
}

/** 사원 한 행 — 헤어라인, 선택 = ink + 옅은 잉크 면 */
export const UserListItem = (props: PropsType) => {
	const user = props.user ?? new User({})
	const showDepartmentName = props.showDepartmentName ?? false

	const RenderUserFrame = ({ children }: { children: React.ReactNode }) => {
		return (
			<View css={style}>
				{props.onUserClick !== undefined ? (
					<ListItemButton
						css={[
							props.userInfoStyle && { ...props.userInfoStyle },
							props.isChecked && props.chechedStyle ? { ...props.chechedStyle } : null,
						]}
						className={`listItem ${
							props.userInfoClassName ? props.userInfoClassName : ''
						} ${props.isChecked ? 'checked' : ''}`}
						onClick={() => {
							if (props.onUserClick) {
								props.onUserClick(user)
							}
						}}
					>
						{children}
					</ListItemButton>
				) : (
					<View
						css={[props.userInfoStyle ? { ...props.userInfoStyle } : {}]}
						className={`listItem view ${
							props.userInfoClassName ? props.userInfoClassName : ''
						} ${props.isChecked ? 'checked' : ''}`}
					>
						{children}
					</View>
				)}
			</View>
		)
	}

	const LeftAccessory = () => {
		return <>{props.userInfoLeftAccessory ? props.userInfoLeftAccessory(user) : null}</>
	}

	return (
		<RenderUserFrame>
			{props.children ? (
				<>{props.children}</>
			) : (
				<ListUserInfo
					user={user}
					isChecked={props.isChecked}
					showDepartmentName={showDepartmentName}
				/>
			)}
			<LeftAccessory />
		</RenderUserFrame>
	)
}

const style = css({
	'.listItem': {
		minHeight: 44,
		padding: '4px 12px',
		marginBottom: 0,
		borderRadius: 0,
		borderBottom: `1px solid ${mono.line}`,
		color: mono.dim,
		transition: 'color 200ms ease-out, background-color 200ms ease-out',

		'&:hover': { color: mono.ink },

		'&.view': {
			padding: '6px 12px',
			textAlign: 'left',
		},

		'&.checked': {
			background: 'rgba(22, 24, 27, 0.05)',
			color: mono.ink,
			boxShadow: `inset 1px 0 0 ${mono.ink}`,
		},
	},
})
